import { useEffect, useState } from 'react';

export default (additionalActions = () => { }) => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);

    additionalActions();
  };

  useEffect(() => {
    handleWindowSizeChange();

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return {
    isMobile: width <= 600,
    isBigMobile: width > 600 && width <= 800,
    isTablet: width > 600 && width <= 1024,
    isDesktop: width > 1024,
  };
};
